import {
  Button,
  Form,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from '@heroui/react'
import { Plus } from 'lucide-react'
import { useSearchParams } from 'react-router-dom'
import { useCreateSchema, usePatchSchema, useSchema } from './utils'

export default function SchemaInfoModal({ isEdit = false }) {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('schema')

  const { isOpen, onOpen, onOpenChange } = useDisclosure()

  const { mutate: createSchema } = useCreateSchema()
  const { mutate: updateSchema } = usePatchSchema()
  const { data: selectedSchema } = useSchema(id)

  const onSubmit = async (e) => {
    e.preventDefault()
    const data = Object.fromEntries(new FormData(e.currentTarget))
    if (isEdit) {
      updateSchema({ id, ...data })
    }
    else {
      createSchema(data)
    }
    onOpenChange()
  }

  return (
    <>
      {isEdit
        ? (
            <Button onPress={onOpen} size="sm" radius="sm" variant="flat" color="default">
              Edit
            </Button>
          )
        : (
            <Button disableRipple onPress={onOpen} size="sm" radius="sm" variant="bordered" color="default" fullWidth>
              <Plus size={16} />
              Create new schema
            </Button>
          )}
      <Modal
        radius="sm"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        classNames={{
          footer: 'ml-auto',
          body: 'flex flex-col gap-5 w-full pt-4',
          header: 'border-b border-gray-200 bg-[#18181b] w-full',
        }}
      >
        <ModalContent>
          {onClose => (
            <Form onSubmit={onSubmit}>
              <ModalHeader className="flex flex-col gap-1">
                <h2 className="text-2xl font-taurus text-white font-semibold flex items-center gap-3">
                  {isEdit ? 'Edit schema' : 'Create new schema'}
                </h2>
                <p className="text-xs font-taurus font-light tracking-wider text-foreground-400">Create a new schema to extract information from your conversations.</p>
              </ModalHeader>
              <ModalBody>

                <Input
                  isRequired
                  label="Name"
                  name="name"
                  variant="bordered"
                  defaultValue={isEdit ? selectedSchema?.name : undefined}
                  radius="sm"
                  labelPlacement="outside"
                  placeholder="Enter a name for your new schema"
                />

                <Input
                  name="description"
                  label="Description"
                  variant="bordered"
                  radius="sm"
                  labelPlacement="outside"
                  placeholder="This schema is used to extract information from customer support calls"
                  defaultValue={isEdit ? selectedSchema?.description : undefined}
                />

              </ModalBody>
              <ModalFooter>
                <Button color="danger" radius="sm" variant="light" onPress={onClose}>
                  Close
                </Button>
                <Button color="primary" radius="sm" type="submit">
                  {isEdit ? 'Update' : 'Create'}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}
